export default __webpack_public_path__ + "static/media/tcqn.5f1cf337.png";